import { NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { TranslateModule, TranslateLoader } from '@ngx-translate/core';
import { TranslateHttpLoader } from '@ngx-translate/http-loader';
import { HttpClientModule, HttpClient } from '@angular/common/http';
import { CommonModule } from '@angular/common';

import { RegisterComponent } from './register.component';
import { AppBreadcrumbModule } from '@coreui/angular';
import { AppMaterialModule } from '../../../app-material/app-material.module';
import { LanguageModule } from '../../../core-components/language/language.module';
import { FlexLayoutModule } from '@angular/flex-layout';
import { RegisterRoutingModule } from './register-routing.module';
import { HeaderModule } from '../../../core-components/header/header.module';
import { FooterModule } from '../../../core-components/footer/footer.module';
import { InputErrorPipeModule } from '../../../pipes/input-error-pipe.module';

export function HttpLoaderFactory(http: HttpClient) {
  return new TranslateHttpLoader(http);
}

@NgModule({
  imports: [
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    AppMaterialModule,
    AppBreadcrumbModule,
    HttpClientModule,
    TranslateModule,
    LanguageModule,
    FlexLayoutModule,
    RegisterRoutingModule,
    HeaderModule,
    FooterModule,
    InputErrorPipeModule
  ],
  declarations: [RegisterComponent],
  bootstrap: [RegisterComponent]
})
export class RegisterModule { }
